function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLexikon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Lexikon",
    transform: "matrix(1,0,0,1,11.7615,9.94909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.141,-0C25.576,-0 25.93,0.353 25.93,0.79C25.93,1.226 25.576,1.58 25.141,1.58L3.543,1.58C2.866,1.58 2.31,2.143 2.25,2.858C2.31,3.458 2.866,3.931 3.543,3.931L25.141,3.931C25.576,3.931 25.93,4.285 25.93,4.72L25.93,29.211C25.93,29.646 25.576,30 25.141,30L25.158,29.998L3.037,29.999C1.806,29.982 0.793,28.998 0.677,27.748L0.666,27.508L0.666,2.755C0.666,1.235 1.956,-0 3.543,-0L25.141,-0ZM2.245,5.213L2.245,27.508C2.245,27.955 2.538,28.329 2.923,28.407L3.071,28.421L3.963,28.421L3.963,8.073C3.963,7.636 4.316,7.283 4.751,7.283C5.139,7.283 5.462,7.562 5.529,7.931L5.541,8.073L5.541,28.421L24.351,28.421L24.351,5.51L3.543,5.51C3.076,5.51 2.636,5.403 2.245,5.213Z",
    style: {
      fill: "white"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLexikon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Lexikon.79efa40b.svg";
export { ForwardRef as ReactComponent };